import classNames from 'classnames';
import PropTypes from 'prop-types';

function Divider(props) {
  const {
    className,
    style,
    vertical,
    visible = true,
  } = props;

  return (
    <div
      style={style}
      className={classNames(
        {
          'w-4 py-2 h-full flex justify-center items-center': vertical,
          'h-4 px-4 w-full flex justify-center items-center': (!vertical),
        },
        className,
      )}
    >
      {(visible)
        ? (
            <div className={classNames(
              'bg-pxBgMuted/50',
              {
                'h-full w-px': vertical,
                'w-full h-px': !vertical,
              },
            )}
            />
          )
        : null}
    </div>
  );
}

Divider.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({}),
  vertical: PropTypes.bool,
  visible: PropTypes.bool,
};

export default Divider;
